import moment from 'moment'
import { isNil } from 'lodash-es'
import { ValueFormatterParams } from 'ag-grid-community'
import { IndexDetail } from 'api'
import { TypedValueGetterParams } from 'view/components/datagrid'
import { Locale } from 'locale'

export const VALID_FOR_FORMAT = 'YYYY-MM-DD'
export const PRICE_FORMAT_OPTIONS = { minDp: 2 }

export function newestValidForGetter(params: TypedValueGetterParams<IndexDetail>) {
  if (!params.data) {
    return null
  }
  return moment.max(Object.keys(params.data.index.values).map(date => moment(date))).format(VALID_FOR_FORMAT)
}

export function newestPriceGetter(params: TypedValueGetterParams<IndexDetail>) {
  if (!params.data) {
    return null
  }
  const newestValidFor = moment.max(Object.keys(params.data.index.values).map(date => moment(date))).format(VALID_FOR_FORMAT)
  return params.data.index.values[newestValidFor]
}

export function formatValidFor(validFor: string) {
  return moment(validFor).format('MMM YYYY')
}

export function validForFormatter(params: ValueFormatterParams) {
  return isNil(params.value) ? '' : formatValidFor(params.value)
}

export function formatPrice(price: number) {
  return Locale.formatNumber(price, PRICE_FORMAT_OPTIONS)
}

export function priceFormatter(params: ValueFormatterParams) {
  return isNil(params.value) ? '' : formatPrice(params.value)
}
